<app-navbar-style-two></app-navbar-style-two>

<!-- Start Page Title Area -->
<div class="page-title-area page-title-style-two">
    <div class="container">
        <div class="page-title-content pt-2">
            <h2 class="font-family005">Contact Us</h2>
            <ul class="font-family005">
                <li><a routerLink="/"><i class="bx bx-home"></i> Home</a></li>
                <li class="active">Contact Us</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Contact Area -->
<section class="main-contact-area py-5">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-8 col-md-12">
                <div class="contact-wrap">
                    <div class="contact-form">
                        <div class="contact-title">
                            <h2 class="font-family005">Write Us</h2>
                        </div>
                        <form [formGroup]="FormData" (ngSubmit)="onSubmit()">
                            <div class="row">
                                <div class="col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <label class="font-family004">Name</label>
                                        <input class="form-control" name="name" placeholder="Full Name" formControlName="name" [ngClass]="{ 'is-invalid': submitted && f.name.errors }">
                                        <div *ngIf="submitted && f.name.errors">
                                            <small *ngIf="f.name.errors.required" class="form-text text-danger">Name is required</small>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <label class="font-family004">Email Address</label>
                                        <input type="text" name="email" placeholder="Enter email" formControlName="email" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                                        <div *ngIf="submitted && f.email.errors" class="form-text text-danger">
                                            <small *ngIf="f.email.errors.required">Email is required</small>
                                            <small *ngIf="f.email.errors.email">Email must be a valid email address</small>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <label class="font-family004">Subject</label>
                                        <input name="subject" placeholder="Enter Subject" formControlName="subject" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.subject.errors }">
                                        <div *ngIf="submitted && f.subject.errors">
                                            <small *ngIf="f.subject.errors.required" class="form-text text-danger">Subject is required</small>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <label class="font-family004">Message</label>
                                        <textarea name="message" placeholder="Enter Message" formControlName="message" class="form-control" cols="30" rows="10" [ngClass]="{ 'is-invalid': submitted && f.message.errors }"></textarea>
                                        <div *ngIf="submitted && f.message.errors">
                                            <small *ngIf="f.message.errors.required" class="form-text text-danger">Message is required</small>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-12 col-md-12">
                                    <button type="submit" class="default-btn btn-two"><span>Send Message</span></button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="contact-info">
                    <h3 class="font-family005">Our contact details</h3>
                    <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.</p> -->

                    <ul class="address font-family004">
                        <li class="location">
                            <i class="bx bxs-location-plus"></i>
                            <span>Address</span>
                          Plot no : 143, Ist floor IIFL Towers 
                          MGR salai Perungudi, Chennai - 600096
                        </li>
                        <li>
                            <i class="bx bxs-phone-call"></i>
                            <span>Phone</span>
                            <a href="tel:+15143125678">044 24612769</a>
                            <!-- <a href="tel:+15143126677">+1 (514) 312-6677</a> -->
                        </li>
                        <li>
                            <i class="bx bxs-envelope"></i>
                            <span>Email</span>
                            <a href="mailto:info@bontonsoftwares.com">info@bontonsoftwares.com
                        </a>
                            <!-- <a href="#">skype: example</a> -->
                        </li>
                    </ul>

                    <div class="sidebar-follow-us">
                        <h3 class="font-family005">Follow us:</h3>
                        <ul class="social-wrap">
                            <li><a href="#" target="_blank"><i class="bx bxl-twitter"></i></a></li>
                            <li><a href="#" target="_blank"><i class="bx bxl-instagram"></i></a></li>
                            <li><a href="#" target="_blank"><i class="bx bxl-facebook"></i></a></li>
                            <li><a href="#" target="_blank"><i class="bx bxl-youtube"></i></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Contact Area -->

<!-- Start Map Area -->
<div class="map-area">
  <iframe src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d216176.1214868377!2d80.10225852392702!3d12.893211766802853!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1s%20Plot%20no%20%3A%20143%2C%20Ist%20floor%20IIFL%20Towers%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20MGR%20salai%20Perungudi%2C%20Chennai%20-%20600096!5e1!3m2!1sen!2sin!4v1749317102252!5m2!1sen!2sin &hl=en&q=bonton softwares&t=&z=14&" width="600" height="400" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
<!--     <iframe src="https://maps.google.com/maps?width=600&height=400&hl=en&q=bonton softwares&t=&z=14&ie=UTF8&iwloc=B&output=embed"></iframe> -->
</div>
<!-- End Map Area -->
